import * as classNames from 'classnames';
import { DatePickerCalendar } from 'components/calendar';
import { DropdownContainer } from 'components/list';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import * as moment from 'moment';
import * as React from 'react';

// Styles
const s = require('./DatePickerDropdown.css');
const iconTickWhite = require('assets/tick white.svg');

// Props
interface IDatePickerDropdownProps {
    onChange: ((date: moment.Moment | null) => void) | null;
    className?: string | null;
    label?: string | null;
    noDateLabel?: string | null;
    type?: 'oneline' | 'twolines' | 'field';
    value?: any;
    valueCanBeCleared?: boolean;
    dateFormat?: string;
    closeOnChange?: boolean;
}

@observer
export class DatePickerDropdown extends React.Component<
    IDatePickerDropdownProps,
    {}
> {
    static get defaultProps(): IDatePickerDropdownProps {
        return {
            onChange: null,
            className: null,
            label: null,
            noDateLabel: 'No date selected',
            value: null,
            valueCanBeCleared: false,
            dateFormat: 'M/DD/YYYY',
            closeOnChange: true,
        };
    }

    constructor(props: IDatePickerDropdownProps) {
        super(props);

        this.state = {
            date: null,
            dateSelected: '',
            dateLabel: '',
        };
    }

    @computed private get date(): {
        value: moment.Moment | null;
        formatted: string | null;
    } {
        if (this.props.value !== null) {
            if (
                typeof this.props.value.isValid !== 'undefined' &&
                this.props.value.isValid()
            ) {
                return {
                    value: this.props.value,
                    formatted: this.props.value.format(this.props.dateFormat),
                };
            } else {
                const parseDate: moment.Moment = moment(this.props.value);
                return parseDate.isValid()
                    ? {
                          value: parseDate,
                          formatted: parseDate.format(this.props.dateFormat),
                      }
                    : {
                          value: null,
                          formatted: null,
                      };
            }
        } else {
            return {
                value: null,
                formatted: null,
            };
        }
    }

    public render() {
        return (
            <DropdownContainer
                ref={this.referenceDropdownContainer}
                className={classNames(this.props.className)}
                minWidth={318}
                maxWidth={318}
                value={this.date.formatted}
                label={
                    this.date.value ? this.props.label : this.props.noDateLabel
                }
            >
                <DatePickerCalendar
                    onChange={this.handleDateChange}
                    value={this.date.value}
                />

                <div
                    className={classNames(s.summary, {
                        [s.approve]: this.date.formatted ? true : false,
                    })}
                >
                    {this.props.valueCanBeCleared && this.date.value !== null && (
                        <div>
                            <button onClick={this.clearValue}>
                                <span>Clear date</span>
                            </button>
                        </div>
                    )}

                    <div>
                        <button onClick={this.closeDropdown}>
                            <span>{this.date.formatted || 'Cancel'}</span>
                            <i>
                                <img src={iconTickWhite} />
                            </i>
                        </button>
                    </div>
                </div>
            </DropdownContainer>
        );
    }

    private dropdownContainer: DropdownContainer = null;
    private referenceDropdownContainer = (ref: DropdownContainer) =>
        (this.dropdownContainer = ref);

    private clearValue = () => {
        this.handleDateChange(null);
        this.closeDropdown();
    };

    private closeDropdown = () => {
        if (this.dropdownContainer) {
            this.dropdownContainer.closeDropdown();
        }
    };

    private handleDateChange = (date: moment.Moment | null) => {
        if (this.props.onChange) {
            this.props.onChange(date);
        }

        if (this.props.closeOnChange) {
            this.closeDropdown();
        }
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/calendar/DatePickerDropdown.tsx